<template>
  <div class="contauner-fliud">
    <footer>
      <div class="footer-content">
       <!-- bisense.cn 域名配置 -->
        <p>版权所有 © 2019 Bisense 百信 | <a href="http://beian.miit.gov.cn/" target="_blank">豫ICP备11014876</a>
        <a href="https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=914101057708526727-SAIC_SHOW_1000009141010577085267271601017799809&signData=MEQCIJ5hHEbqo2JYmb69lIPMuW31hMCzAnt/1QgkRsvCyBFeAiDfH8DUysrNdAITXikCXo3UT9tGARnGihDRyQvsNUT7Hw==">
          <img src="../assets/img/lz.png" alt="">
        </a>
        </p>
         <!-- zzrunta.com 域名配置 -->
         <!-- <p>Copyright © 2022  Bisense 百信 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="http://beian.miit.gov.cn/" target="_blank">豫ICP备17009946号</a> 
           <a target="_blank" href="https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&amp;serial=91410100MA3XBC1D80-SAIC_SHOW_10000091410100MA3XBC1D801600507207011&amp;signData=MEQCIGB961bKM5Ugtf46bl3h5A5V7OCtZLzln8xYb1f73fuTAiAW8cfl6OMwGUUWozYikbtNIPdzJUyiXu1heIxj7peoqQ==">
         <img style="width: 30px;margin-left: 20px;vertical-align: middle;" src="@/assets/img/lz.png"></a></p> -->
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  data(){
    return{}
  },
  methods:{
   
  },
  mounted(){
   
  },
}
</script>
<style scoped lang="scss">
  @import '@/lib/reset.scss';
  .contauner-fliud{
    width:100%;
    height: auto;
  }
  footer{
    height: 50px;
    width: 100%;
    text-align: center;
    font-size: 14px;
    background-color: #fff;
    color: #888888;
    margin-top: -50px;
    position: relative;
    z-index: 2
  }
  .footer-content{
    line-height: 50px;
    text-align: center;
  }
  .footer-content  a{
    color: #888888;
    cursor: pointer;
  }
  .footer-content  a img{
    width: 1.7%;
    margin-left:10px;
    vertical-align: middle;
    margin-top:-2px;
  }
  @media screen and (max-width:1680px) and (min-width:1440px){
    footer{
      height:48px;
    }
    .footer-content{
      line-height:48px;
      text-align: center;
    }
    .footer-content  a img{
      width: 1.8%; 
    }
  }
  @media screen and (max-width:1440px) and (min-width:1366px){
    footer{
      margin-top: -42px;
      height: 40px;
    }
    .footer-content{
      line-height:45px;
      text-align: center;
    }
    .footer-content  a img{
      width: 1.8%; 
    }
  }
  @media screen and (max-width:1366px) and (min-width:1280px){
    footer{
      margin-top: -40px;
      height:40px;
    }
    .footer-content{
      line-height:40px;
      text-align: center;
    }
    .footer-content  a img{
      width: 1.8%; 
    }
  }
  @media screen and (max-width:1280px) and (min-width:1024px){
    footer{
      margin-top: -36px;
      height: 36px;
    }
    .footer-content{
      line-height: 36px;
      text-align: center;
    }
  }
  @media screen and (max-width:1024px)and (min-width:650px){
    footer{
      margin-top: -30px;
      height: 30px;
    }
    .footer-content{
      line-height: 30px;
      text-align: center;
    }
    .footer-content  a img{
      width: 1.9%; 
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue